import React from 'react';
import s from './s.module.less';
import { Button, Tabs, TabsProps } from 'antd';
import { setHasShowTextVisitPage } from 'utils/localstore';
import Benefits from '../Benefits';
import HowItWork from '../HowItWork';
import FAQComponent from '../FAQ';
import Frame from '../imgs/Frame.jpg';

enum ESection {
    BENEFITS = 'benefits',
    FAQ = 'faq',
    HOW_IT_WORKS = 'howItWorks',
}

type Props = {
    isModal?: boolean;
    onGetStarted?: () => void;
};
const TextVisitLandingPage = (props: Props) => {
    const { isModal, onGetStarted } = props;
    const [activeId, setActiveId] = React.useState(ESection.BENEFITS);
    const [isScrolling, setIsScrolling] = React.useState(false);

    const guideItems: TabsProps['items'] = [
        {
            key: ESection.BENEFITS,
            label: <div>Benefits</div>,
            children: <div />,
        },
        {
            key: ESection.HOW_IT_WORKS,
            label: <div>How it works</div>,
            children: <div />,
        },
        {
            key: ESection.FAQ,
            label: <div>FAQs</div>,
            children: <div />,
        },
    ];

    const handleChange = (activeKey: string) => {
        setIsScrolling(true);
        setActiveId(activeKey as ESection);
        const element = document.getElementById(activeKey as string);
        const wrapElement = document.getElementById('contentWrap');
        wrapElement?.scrollTo({
            top: (element as HTMLBaseElement).offsetTop - 150,
            behavior: 'smooth',
        });
        setIsScrolling(false);
    };

    React.useEffect(() => {
        const wrap = document.getElementById('contentWrap');
        const first = document.getElementById(ESection.BENEFITS);
        const second = document.getElementById(ESection.HOW_IT_WORKS);
        const third = document.getElementById(ESection.FAQ);
        const handle = () => {
            const top = wrap?.scrollTop;
            const slug = 500;
            if (third && top && (top + slug) > third?.offsetTop) {
                setActiveId(ESection.FAQ);
            } else if (second && top && (top + slug) > second?.offsetTop) {
                setActiveId(ESection.HOW_IT_WORKS);
            } else {
                setActiveId(ESection.BENEFITS);
            }
        };
        wrap?.addEventListener('scroll', handle);
        return () => {
            wrap?.removeEventListener('scroll', handle);
        };
    }, []);

    return (
        <div
            className={s.wrap}
            id="contentWrap"
        >
            <div className={s.header}>
                <div className={s.left}>
                    <div className={s.title}>
                        Earn more in minutes: Try <span style={{ color: '#0E62F4' }}>Text Visits</span> today
                    </div>
                    <div className={s.des}>
                        With text visit, patients respond to a structured intake form, and you reply when it’s convenient. No live appointments needed. All messaging-based, including follow-up questions. Each case takes just minutes—perfect for earning extra income between video visits or during downtime.
                    </div>
                    {
                        !isModal && (
                            <div className={s.startBtn}>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setHasShowTextVisitPage(true);
                                        onGetStarted?.();
                                    }}
                                >Get started
                                </Button>
                            </div>
                        )
                    }
                </div>
                <div className={s.right}>
                    <img src={Frame} />
                </div>
            </div>
            <div className={s.tabs}>
                <Tabs
                    activeKey={activeId}
                    items={guideItems}
                    onChange={(activeKey) => handleChange(activeKey)}
                />
            </div>
            <div className={s.content} id={ESection.BENEFITS}>
                <Benefits />
            </div>
            <div className={s.content} id={ESection.HOW_IT_WORKS}>
                <HowItWork />
            </div>
            <div className={s.content} id={ESection.FAQ}>
                <FAQComponent />
            </div>
        </div>
    );
};

export default TextVisitLandingPage;